module.exports = __webpack_public_path__ + "img/s-1.196123d9.png";